import React from 'react'
import {Button} from 'semantic-ui-react'

const getHeader=()=>{

    return (<tr>
    <th>
        <div>
            Dr Name
        </div>

    </th>
    <th>
        <div>
            Category
        </div>
    </th>
    <th>
        <div>
            Amount
        </div>
    </th>
</tr>)
}

const getDetailsHeader=(type)=>{
    return (<tr>
        <th>
            <div>
                Pat Num
            </div>
        </th>
        <th><div>Category</div></th>
        <th><div>Practice</div></th>
        <th><div>TED</div></th>
        <th><div>Dr Name</div></th>
        {(type==='collectionsHynList')&&<th><div>Treating Provider</div></th>}
        <th><div>Proc Date</div></th>
        <th><div>Entry/Deposit Date</div></th>
        <th><div>Amount</div></th>
    </tr>)
}

  const getTableRows=(groupBy, data,collType)=>{
    const collectionsData = collType==='collections' ?data.collectionsList:data.hygCollectionList;
    const collEntryStartDate =data.collectionsEntryStartDate? data.collectionsEntryStartDate : "00-00";
    const collProcStartDate = data.collectionsProcedureStartDate? data.collectionsProcedureStartDate : "00-00";
    const collectionObj=groupBy(collectionsData,'Category',collEntryStartDate,collProcStartDate);
    if (Object.keys(collectionObj).length) {
        let totalAmount = 0;
        let ReturnArray = [];
        Object.keys(collectionObj).forEach((category,indx) => {
            let categoryTotal = 0;
            const categoryName = category;
            let categoryIndex = 0;
            collectionObj[category].forEach((collection, i) => {
                categoryTotal += collection.Amount;
                totalAmount += collection.Amount;
            })
            ReturnArray.push(
                <tr key={`${indx}-1a`}>
                    <td>{collectionObj[category][0]?.Abbr.includes('HYG')?collectionObj[category][0].DrName?.replace(/^Dr\.\s+/, '')?.concat(', RDH'):collectionObj[category][0].DrName}</td>
                    <td>{categoryName}</td>
                    <td>$ {categoryTotal.toFixed(2)}</td>
                </tr>
            );
        })
        ReturnArray.push(
            <tr key={'total'}>
                <td colSpan="2"><strong>Total</strong></td>
                <td><strong>$ {totalAmount.toFixed(2)}</strong></td>
            </tr>
        );
        return ReturnArray;

    }
    else {
        return (        
                <tr>
                    <td colSpan="3">No Record Found</td>
                </tr>
        );
    }

  }

  const getDetailedTableRows=(data,getPracticeName,type,collectionType)=>{
    let returnColumns = [];
    const collectionList = collectionType === 'collections'?data.collectionsList:data.hygCollectionList;
    const collEntryStartDate =data.collectionsEntryStartDate? data.collectionsEntryStartDate : "00-00";
    const collProcStartDate = data.collectionsProcedureStartDate? data.collectionsProcedureStartDate : "00-00";
    if (collectionList.length > 0) {
        let totalAmount = 0;
        collectionList.forEach((collection, i) => {
            if(collection.EntryDate>=collEntryStartDate && collection.ProcDate>=collProcStartDate){
            totalAmount += collection.Amount;
            collection.PracticeName = getPracticeName(collection.Practice)
            returnColumns.push(
                <tr key={`${i}-2`}>
                    <td className="primaryColor cursorPointer"><span >{collection.PatNum}</span></td>
                    <td>{collection.Category}</td>
                    <td>{collection.PracticeName}</td>
                    <td>{collection.isTedDay ? 'Yes' : 'No'}</td>
                    <td>{collection.Abbr?.includes('HYG')?collection?.DrName?.replace(/^Dr\.\s+/, '')?.concat(', RDH'):collection?.DrName}</td>
                    {(type==='collectionsHynList')&&<td>{collection.TreatingProvider}</td>}
                    <td>{collection.ProcDate}</td>
                    <td>{collection.EntryDate}</td>
                    <td>$ {collection.Amount.toFixed(2)}</td>
                </tr>
            );
        }
        })
        returnColumns.push(
            <tr key={'total'}>
                <td colSpan={type === 'collectionsHynList' ? 8 : 7}><strong>Total</strong></td>
                <td><strong>$ {totalAmount.toFixed(2)}</strong></td>
            </tr>
        );
    } else {
        returnColumns.push(
                <tr>
                    <td colSpan="8">No Record Found</td>
                </tr>
        )
    }
    return returnColumns ;
   }

function CollectionsListTable (props) {
      const {detailsModal,getPracticeName, groupBy}=props;
      // TED-only view: same table as collectionsBillableCare, but restricted to collections
      // whose ProcDate fell on a TED-scheduled day (isTedDay set by the backend).
      const isTedOnly = props.type === 'tedCollections';
      const type = isTedOnly ? 'collectionsBillableCare' : props.type;
      const details = isTedOnly
        ? { ...props.details, collectionsList: (props.details?.collectionsList ?? []).filter(c => c.isTedDay) }
        : props.details;
    return (<div>  
              <table className="table table-striped fixed compact table-hover my-0 TableHeaderFixed">
            <thead>
                {props.detailsModal==='details'?getDetailsHeader(type):getHeader()}
            </thead>
            <tbody>
                 {(detailsModal==='details' && type === 'collectionsBillableCare')?getDetailedTableRows(details,getPracticeName,'','collections'):(type !== 'collectionsHynList'?getTableRows(groupBy, details,'collections'):'')}
                {(detailsModal==='details' && type === 'collectionsHynList')?getDetailedTableRows(details,getPracticeName,type,'collectionsHyg'):(type !== 'collectionsBillableCare'?getTableRows(groupBy, details,'collectionsHyg'):'')}
            </tbody>
        </table>
        {props.detailsModal!=='details' && type === 'collectionsBillableCare'?<Button primary className="mr-0 mt10 float-right" onClick={ () => props.onSelectEvent({ type: props.type, id: '' }, 'details') }>
                      Report Details
                    </Button>:''}
        {props.detailsModal!=='details' && type === 'collectionsHynList'?<Button primary className="mr-0 mt10 float-right" onClick={ () => props.onSelectEvent({ type: 'collectionsHynList', id: '' }, 'details') }>
                      Report Details
                    </Button>:''}
        </div>

    )
    
  }

  export default CollectionsListTable